import { FC, PropsWithChildren, ReactNode } from 'react';

import { clsx } from 'clsx';

import { Container } from '@shared/ui/Container';
import { VStack } from '@shared/ui/Stack';

import cls from './PageWithMenu.module.scss';

type PageWithMenuProps = {
  menu: ReactNode;
  classNameMenu?: string;
  classNameContainer?: string;
  classNameContent?: string;
};

export const PageWithMenu: FC<PropsWithChildren<PageWithMenuProps>> = ({
  menu,
  children,
  classNameMenu,
  classNameContainer,
  classNameContent
}) => {
  return (
    <Container className={clsx(cls.container, classNameContainer)}>
      <VStack className={clsx(cls.menu, classNameMenu)}>{menu}</VStack>
      <section className={clsx(cls.wrapper, classNameContent)}>{children}</section>
    </Container>
  );
};
